<template>
    <div style="padding: 16px 3vw; display: flex; align-items: center; flex-direction: column;">
        <h1>Infamy! Infamy! Table Generator</h1>
        <div class="regions">
            <div class="label">Region:</div>
            <div>
                <label v-for="region in regions" v-bind:key="region.id">
                    <input type="radio"
                           name="region"
                           :value="region"
                           :checked="region.name === gameTable.region.name"
                           @click="gameTable.region = region">{{ region.name }}
                </label>
            </div>
        </div>
        <div style="margin: 16px 0;">
            <button @click="generateTable">Generate table</button>
        </div>
        <div style="margin-top: 32px; width: 100%;" v-if="gameTable.isInitialized">
            <table style="text-align: center; width: 100%;">
                <thead>
                <tr>
                    <th>
                        <div><img src="../assets/tiles/small/hill.png" alt="">Hills</div></th>
                    <th>
                        <div><img src="../assets/tiles/small/tree3.png" alt="">Woods</div></th>
                    <th>
                        <div><img src="../assets/tiles/small/marsh.png" alt="">Marshes</div></th>
                    <th>
                        <div><img src="../assets/tiles/small/habitation3.png" alt="">Habitations</div></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td><span class="number">{{ gameTable.hillsCount }}</span></td>
                    <td><span class="number">{{ gameTable.woodsCount }}</span></td>
                    <td><span class="number">{{ gameTable.marshCount }}</span></td>
                    <td><span class="number">{{ gameTable.habitationCount }}</span></td>
                </tr>
                </tbody>
            </table>
        </div>
        <div style="margin-top: 32px;">
            <canvas ref="canvas"></canvas>
        </div>
    </div>
</template>

<script>
  import GameTable from '@/models/GameTable';
  import Regions from '@/models/Regions';
  import TerrainTypes from '@/models/TerrainTypes';
  import g0 from '../assets/tiles/grass/grass-tile-0000.jpg';
  import g1 from '../assets/tiles/grass/grass-tile-0001.jpg';
  import g2 from '../assets/tiles/grass/grass-tile-0002.jpg';
  import g3 from '../assets/tiles/grass/grass-tile-0003.jpg';
  // import g4 from '../assets/tiles/grass/grass-tile-0004.jpg';
  // import g5 from '../assets/tiles/grass/grass-tile-0005.jpg';
  // import g6 from '../assets/tiles/grass/grass-tile-0006.jpg';
  // import g7 from '../assets/tiles/grass/grass-tile-0007.jpg';
  import g8 from '../assets/tiles/grass/grass-tile-0008.jpg';
  // import g9 from '../assets/tiles/grass/grass-tile-0009.jpg';
  import g10 from '../assets/tiles/grass/grass-tile-0010.jpg';
  import g11 from '../assets/tiles/grass/grass-tile-0011.jpg';
  import g12 from '../assets/tiles/grass/grass-tile-0012.jpg';
  // import g13 from '../assets/tiles/grass/grass-tile-0013.jpg';
  // import g14 from '../assets/tiles/grass/grass-tile-0014.jpg';
  // import g15 from '../assets/tiles/grass/grass-tile-0015.jpg';
  // import g16 from '../assets/tiles/grass/grass-tile-0016.jpg';
  // import g17 from '../assets/tiles/grass/grass-tile-0017.jpg';
  // import g18 from '../assets/tiles/grass/grass-tile-0018.jpg';
  // import g19 from '../assets/tiles/grass/grass-tile-0019.jpg';
  import ImageMarsh from '../assets/tiles/small/marsh.png';
  import ImageTree from '../assets/tiles/small/tree3.png';
  import ImageHill from '../assets/tiles/small/hill.png';
  import ImageHabitation from '../assets/tiles/small/habitation3.png';
  import ImageRiver from '../assets/tiles/small/river.jpg';
  import ImageFord from '../assets/tiles/small/ford.png';
  import ImageBridge from '../assets/tiles/small/bridge.png';

  export default {
    name: 'TableGenerator',
    props: {
      msg: String
    },
    data() {
      return {
        regions: Regions,
        gameTable: new GameTable(),
        grassTiles: [g0, g1, g2, g3, g8, g10, g11, g12],
      };
    },
    computed: {
      canvas() {
        return this.$refs.canvas;
      },
      pixelRatio() {
        const c = this.canvas;
        const ctx = c.getContext('2d');
        return (() => {
          const dpr = window.devicePixelRatio || 1;
          const bsr = ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio || 1;
          return dpr / bsr;
        })();
      },
    },
    methods: {
      getContainerWidth(selector) {
        const container = window.document.querySelector(selector);
        return container == null ? 0 : container.clientWidth;
      },
      generateTable() {
        this.gameTable = new GameTable(this.gameTable.region);
        this.gameTable.generateTerrain();
        const ctx = this.canvas.getContext('2d');
        this.canvas.width = this.canvas.offsetWidth * this.pixelRatio;
        this.canvas.height = this.canvas.offsetHeight * this.pixelRatio;
        const width = this.canvas.width;
        // const height = this.canvas.height;
        // ctx.fillStyle = '#adcd6d';
        // ctx.fillRect(0, 0, width, height);

        const pixelsPerInch = width / (this.gameTable.widthInInches);
        let toLoad = (this.gameTable.widthInInches / 12) * (this.gameTable.heightInInches / 12);
        for (let x = 0; x <= this.gameTable.widthInInches / 12; x += 1) {
          for (let y = 0; y <= this.gameTable.heightInInches / 12; y += 1) {
            const img = this.grassTiles[Math.floor(Math.random() * this.grassTiles.length)];
            const image = new window.Image(12 * pixelsPerInch, 12 * pixelsPerInch);
            image.addEventListener('load', () => {
              const imageSize = 180;
              ctx.drawImage(image, 0, 0, imageSize, imageSize, x * 12 * pixelsPerInch, y * 12 * pixelsPerInch, 12 * pixelsPerInch, 12 * pixelsPerInch);
              toLoad -= 1;
            });
            image.src = img;
          }
        }

        const waitForImagesToLoad = () => {
          if (toLoad > 0) {
            setTimeout(waitForImagesToLoad, 100);
          } else {
            this.gameTable.features.forEach((f) => {
              let src = null;
              let srcSize = 256;
              let rotation = 0;
              switch (f.terrainType.id) {
                case TerrainTypes.Woods.id:
                  src = ImageTree;
                  break;
                case TerrainTypes.Hills.id:
                  src = ImageHill;
                  break;
                case TerrainTypes.Marsh.id:
                  src = ImageMarsh;
                  break;
                case TerrainTypes.Habitation.id:
                  src = ImageHabitation;
                  break;
                case TerrainTypes.River.id:
                  src = ImageRiver;
                  break;
                case TerrainTypes.RiverCrossing.id:
                  src = this.gameTable.riverCrossing === 'Ford'
                    ? ImageFord
                    : ImageBridge;
                  rotation = this.gameTable.crossingAngle;
                  break;
                default:
                  src = null;
                  break;
              }
              if (src != null) {
                const image = new window.Image(12 * pixelsPerInch, 12 * pixelsPerInch);
                image.addEventListener('load', () => {
                  if (rotation > 0) {
                    const x = f.position.x * pixelsPerInch + f.size * pixelsPerInch / 2;
                    const y = f.position.y * pixelsPerInch + f.size * pixelsPerInch / 2;
                    ctx.translate(x, y);
                    ctx.rotate(rotation);
                    ctx.drawImage(image, 0, 0, srcSize, srcSize, -f.size * pixelsPerInch / 2, -f.size * pixelsPerInch / 2, f.size * pixelsPerInch, f.size * pixelsPerInch);
                    ctx.rotate(-rotation);
                    ctx.translate(-x, -y);
                  } else {
                    ctx.drawImage(image, 0, 0, srcSize, srcSize, f.position.x * pixelsPerInch, f.position.y * pixelsPerInch, f.size * pixelsPerInch, f.size * pixelsPerInch);
                  }
                });
                image.src = src;
              }
              // console.log(ctx.fillStyle);
              // console.log(`${f.position.x},${f.position.y}`);
              // console.log(f.position.x * pixelsPerInch);
              // console.log(f.position.y * pixelsPerInch);
            });
          }
        };
        setTimeout(waitForImagesToLoad, 100);
      },
    },
    mounted() {
      // this.generateTable();
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .number {
        font-family: 'Caesar Dressing', cursive;
        font-size: 1.6em;
    }

    button {
        background: brown;
        border: none;
        padding: 10px 16px;
        color: #fff;
        border-radius: 4px;
        font-weight: 600;
        font-size: 1.1em;
        font-family: 'Marcellus SC', serif;
    }

    .label {
        font-weight: 600;
        margin-right: 3vw;
        margin-bottom: 10px;
    }

    .regions {
        display: flex;
        align-items: center;

        label {
            margin-right: 24px;
            margin-bottom: 10px;
            display: inline-block;
            font-size: 1.1em;

            input {
                margin-right: 10px;
            }
        }
    }

    canvas {
        background: #eee;
        width: 90vw;
        height: 60vw;
        box-shadow: 0 0 8px #00000066;
        border: solid 3px #fff;
    }

    table {
        padding: 0;
        margin: 0;
        border-spacing: 0;
        border: solid 1px #ccc;

        th {
            background: #f7f7f7;
            padding: 6px;

            div {
                display: flex;
                align-items: center;
                justify-content: center;

                img{
                    height: 32px;
                    margin-right: 8px;
                }
            }
        }

        td {
            padding: 6px;
            margin: 0;
            border-spacing: 0;
            border: 0px;
        }
    }

    .game-table {
        border-spacing: 0;
        padding: 0;
        margin: auto;
        max-width: 90vw;
        background: linear-gradient(#7ce664, #3e7432);

        .table-cell {
            width: 30vw;
            height: 30vw;
            display: flex;
            align-items: center;
            justify-content: center;

            .number {
                position: absolute;
                font-size: 1.5vw;
                color: #ffffffcc;
                border-radius: 3vw;
                background: red;
                width: 3vw;
                height: 3vw;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .sub-cells {
                .sub-cell {
                    width: 15vw;
                    height: 15vw;

                    > div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .W {
                        width: 100%;
                        height: 100%;
                        background: darkgreen;
                    }

                    .H {
                        width: 100%;
                        height: 100%;
                        background: lightgreen;

                        > svg {
                            fill: #000000cc;
                            stroke: #000000cc;
                        }
                    }

                    .M {
                        width: 100%;
                        height: 100%;
                        background: saddlebrown;
                    }

                    .B {
                        width: 100%;
                        height: 100%;
                        background: darkslategrey;
                    }

                    svg {
                        width: 50%;
                        height: 50%;
                        fill: #ffffffcc;
                        stroke: #ffffffcc;
                    }
                }
            }
        }
    }
</style>
